import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Modificator nou',
  tabs: {
    [Tab.General]: 'General',
    [Tab.NutritionInfo]: 'Informații nutriționale',
  },
  form: {
    modifier_groups: {
      label: 'Aparține grupurilor de modificatori',
    },
    name: {
      label: 'Nume',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: 'Ref. {{integration}}',
      placeholder: 'ex. referință SKU HubRise',
      read_only_hint:
        'Editabil doar când o integrare HubRise este conectată și sincronizarea meniului este dezactivată.',
    },
    price: {
      label: 'Preț de bază',
      placeholder: 'Opțional',
    },
    is_available: {
      label: 'În stoc',
    },
    is_visible: {
      label: 'Vizibil',
      title: 'Vizibil în meniu',
      subtitle_on: 'Clienții pot vedea această opțiune',
      subtitle_off: 'Ascuns de toți clienții',
    },
    is_available_for_pickup: {
      label: 'Disponibil pentru ridicare',
      subtitle_on: 'Clienții îl pot comanda pentru ridicare',
      subtitle_off: 'Ascuns din meniul de ridicare',
    },
    is_available_for_delivery: {
      label: 'Disponibil pentru livrare',
      subtitle_on: 'Clienții îl pot comanda pentru livrare',
      subtitle_off: 'Ascuns din meniul de livrare',
    },
  },
  availability: {
    title: 'Disponibilitate',
    helper:
      'Vizibilitatea este comutatorul principal. Dezactivați un canal pentru a ascunde această opțiune clienților de ridicare sau livrare, fără a o elimina din meniu.',
    status: {
      both: 'Ambele canale',
      pickup_only: 'Doar ridicare',
      delivery_only: 'Doar livrare',
      hidden: 'Ascuns',
      no_channels: 'Niciun canal',
    },
    warning: {
      no_channels:
        'Această opțiune este vizibilă, dar nu este disponibilă pe niciun canal — clienții nu o pot selecta.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Doar ridicare',
      delivery_only: 'Doar livrare',
      no_channels: 'Niciun canal',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    changes_got_saved: 'Modificările au fost salvate!',
  },
};
